import axios from "../../utils/axiosConfig";
import {
  AddMedicineDTO,
  DeleteMedicineDTO,
  DeleteNonMedicineDTO,
} from "../../dtos/medicine";
import { MedicinePaginationDTO, PaginationDTO } from "../../dtos/manufacturer";

axios.defaults.withCredentials = true;

const getMedicine = async (pharmacy_id: any, dto?: MedicinePaginationDTO) => {
  let url = `/api/pharmacy/medicine/get?pharmacy_id=${pharmacy_id}`;

  // If dto exists, add pagination and search parameters
  if (dto) {
    if (dto.page) url += `&page=${encodeURIComponent(dto.page)}`;
    if (dto.limit) url += `&limit=${encodeURIComponent(dto.limit)}`;
    if (dto.search) url += `&search=${encodeURIComponent(dto.search)}`;
    if (dto.lowStock !== undefined) url += `&lowStock=${dto.lowStock}`;
    if (dto.outOfStock !== undefined) url += `&outOfStock=${dto.outOfStock}`;
    if(dto.medicineWithoutBatch !== undefined) url += `&medicineWithoutBatch=${dto.medicineWithoutBatch}`
  }

  const { data } = await axios.get(url);
  return data;
};

const getAllMedicine = async () => {
  const { data } = await axios.get("/api/pharmacy/medicine/all/get");
  return data;
};

const getAllNonMedicine = async () => {
  const { data } = await axios.get(
    "/api/pharmacy/medicine/all_non_medical/get"
  );
  return data;
};

const AddMedicine = async (medicine: AddMedicineDTO) => {
  const { data } = await axios.post(`/api/pharmacy/medicine/add`, medicine);

  return data;
};

const editMedicine = async (medicine: AddMedicineDTO) => {
  const { data } = await axios.put("/api/pharmacy/medicine/update", medicine);
  return data;
};

const deleteMedicine = async (dto: DeleteMedicineDTO) => {
  const { data } = await axios.delete(
    `/api/pharmacy/medicine/delete?medicine_id=${dto.medicine_id}&pharmacy_id=${dto.pharmacy_id}`
  );
  return data;
};

const MedicineService = {
  getMedicine,
  AddMedicine,
  getAllMedicine,
  getAllNonMedicine,
  editMedicine,
  deleteMedicine,
};

export default MedicineService;
